import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {BaseService} from '../../../../shared/src/lib/services/base.service';
import { merge } from 'es-toolkit';

@Injectable({
  providedIn: 'root'
})
export class BrownfieldsService extends BaseService {
  public item: any = {};
  public meta: any = {};

  constructor(http: HttpClient) {
    super(`${environment.baseUrl}/brownfields/attributes`, http);
  }

  public loadData(search: any): Observable<any> {
    return this.getList(search).pipe(tap(response => {
      if (response.results[0]) {
        merge(this.item, response.results[0]);
      } else {
        this.item = {};
      }

      merge(this.meta, response.meta);
      this.meta.display_fields = ['acres_id'];
      this.meta.type = 'brownfields/attributes';
      this.meta.urlPath = 'brownfields';
      this.meta.subItems = ['brownfield_notes'];
      this.meta.fields.brownfield_notes.verbose_name_plural = 'Notes';
      this.meta.fields.brownfield_notes.verbose_name = 'Note';
      this.meta.fields.brownfield_notes.foreign_key_field = 'brownfields';
      this.meta.fields.brownfield_notes.display_fields = [
        'text', 'created_date', 'created_user', 'last_edited_date', 'last_edited_user'
      ];

      this.meta.fields.brownfield_notes.type = 'brownfields/notes';
    }));
  }
}
